import { render } from "./aiSentence.vue?vue&type=template&id=1f1d5fad"
import script from "./aiSentence.vue?vue&type=script&lang=js"
export * from "./aiSentence.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/aiProduct/aiSentence.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f1d5fad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f1d5fad', __exports__)) {
    console.log('reload')
    api.reload('1f1d5fad', __exports__)
  }
  
  module.hot.accept("./aiSentence.vue?vue&type=template&id=1f1d5fad", () => {
    console.log('re-render')
    api.rerender('1f1d5fad', render)
  })

}


export default __exports__